import { render } from "./exponent.vue?vue&type=template&id=1ec10960&scoped=true&ts=true"
import script from "./exponent.vue?vue&type=script&lang=ts"
export * from "./exponent.vue?vue&type=script&lang=ts"

import "./exponent.vue?vue&type=style&index=0&id=1ec10960&lang=less"
import "./exponent.vue?vue&type=style&index=1&id=1ec10960&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec10960"]])

export default __exports__